import { Link } from '@tanstack/react-router';
import { ChevronLeft, Clock3 } from 'lucide-react';
import type { Case } from '@casetrace/shared';

type CaseRoomHeaderProps = {
  readonly caseId: string;
  readonly caseItem: Case | undefined;
  readonly starredCount: number;
};

export function CaseRoomHeader({ caseId, caseItem, starredCount }: CaseRoomHeaderProps) {
  return (
    <div
      className="flex h-10 shrink-0 items-center justify-between gap-3 border-b px-4"
      style={{ borderColor: 'rgba(255,255,255,0.07)' }}
    >
      <div className="flex min-w-0 items-center gap-3">
        <Link
          to="/cases"
          className="flex items-center gap-1 text-xs text-text-secondary hover:text-text-primary"
        >
          <ChevronLeft size={13} />
          Saker
        </Link>
        {caseItem && (
          <>
            <span className="text-text-tertiary">/</span>
            <span className="truncate text-xs font-medium text-text-primary">{caseItem.navn}</span>
            <span className="shrink-0 text-xs text-text-secondary">{caseItem.saksnummer}</span>
          </>
        )}
      </div>
      <div className="flex shrink-0 items-center gap-2">
        <Link
          to="/cases/$caseId/story"
          params={{ caseId }}
          className="flex items-center gap-2 rounded-md border px-2.5 py-1.5 text-xs font-medium text-text-primary transition-colors hover:border-[#8b9bff]/70 hover:bg-[#8b9bff]/12"
          style={{ borderColor: 'rgba(139,155,255,0.45)', background: 'rgba(139,155,255,0.08)' }}
        >
          <Clock3 size={13} style={{ color: '#8b9bff' }} />
          Relevante i tidslinje
          {starredCount > 0 && (
            <span
              className="rounded px-1 py-0.5 text-[10px] font-semibold"
              style={{ background: 'rgba(139,155,255,0.2)', color: '#8b9bff' }}
            >
              {starredCount}
            </span>
          )}
        </Link>
      </div>
    </div>
  );
}
